import { render } from "./ContactSidebar.vue?vue&type=template&id=57de99e6&scoped=true"
import script from "./ContactSidebar.vue?vue&type=script&lang=js"
export * from "./ContactSidebar.vue?vue&type=script&lang=js"

import "./ContactSidebar.vue?vue&type=style&index=0&id=57de99e6&scoped=true&lang=css"

import exportComponent from "/Users/abayomi/IdeaProjects/microservice-2/harvest-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57de99e6"]])

export default __exports__